import { render, staticRenderFns } from "./PreBookings.vue?vue&type=template&id=708b6bb0&scoped=true&"
import script from "./PreBookings.vue?vue&type=script&lang=js&"
export * from "./PreBookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708b6bb0",
  null
  
)

export default component.exports